import React, { useState, useEffect } from "react";
import DateRangePicker from "./DateRangePicker"; // adjust path
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import dayjs from "dayjs";
import { getSendgridStatsData } from "../../api/authApi";
import { Alert, Snackbar, Typography } from "@mui/material";

const SendgridStatsDownload = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const downloadCSV = async (data, from, to) => {
    if (!data || data.length === 0) return;
    const blob = new Blob([data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `sendgrid-stats-${from}-to-${to}.csv`;
    a.click();

    window.URL.revokeObjectURL(url);
  };

  const handleDownload = async () => {
    if (!startDate || !endDate) return;
    setLoading(true);

    try {
      const from = startDate.format("YYYY-MM-DD");
      const to = endDate.format("YYYY-MM-DD");
      const data = await getSendgridStatsData(from, to);
      await downloadCSV(data, from, to);
    } catch (error) {
      console.error("Download failed:", error);
      setSnackbarMessage(error?.details);
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="body2" color="text.secondary" mb={1}>
        Mail Stats (Per Day)
      </Typography>
      <Snackbar
        open={openSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarMessage.includes("Success") ? "success" : "error"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <DateRangePicker
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
      />

      <Box sx={{ mt: 3 }}>
        <Button
          variant="contained"
          color="primary"
          disabled={!startDate || !endDate || loading}
          onClick={handleDownload}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Download CSV"
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default SendgridStatsDownload;
